module.exports = __webpack_public_path__ + "img/introduction.dc0fc4fd.png";